import React from 'react';
import { Box, FormControl, FormLabel, Input, Select, Option } from '@mui/joy';

export type WebsiteProtocol = 'https://' | 'http://';

interface WebsiteInputProps {
  protocol: WebsiteProtocol;
  domain: string;
  onProtocolChange: (protocol: WebsiteProtocol) => void;
  onDomainChange: (domain: string) => void;
  label?: string;
  placeholder?: string;
}

export const splitWebsiteUrl = (url: string | null | undefined): { protocol: WebsiteProtocol; domain: string } => {
  const value = (url || '').trim();
  if (!value) return { protocol: 'https://', domain: '' };
  const match = value.match(/^(https?:\/\/)(.*)$/i);
  if (match) {
    const proto = match[1].toLowerCase() as WebsiteProtocol;
    return { protocol: proto === 'http://' ? 'http://' : 'https://', domain: match[2] };
  }
  return { protocol: 'https://', domain: value };
};

export const joinWebsiteUrl = (protocol: WebsiteProtocol, domain: string): string => {
  const trimmed = (domain || '').trim();
  return trimmed ? `${protocol}${trimmed}` : '';
};

export const WebsiteInput: React.FC<WebsiteInputProps> = ({
  protocol,
  domain,
  onProtocolChange,
  onDomainChange,
  label = 'Website',
  placeholder = 'example.com',
}) => {
  return (
    <Box>
      {label && <FormLabel>{label}</FormLabel>}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1, mt: label ? 1 : 0 }}>
        <FormControl sx={{ width: { xs: '100%', sm: '110px' } }}>
          <Select
            value={protocol}
            onChange={(_, value) => {
              if (value) onProtocolChange(value as WebsiteProtocol);
            }}
          >
            <Option value="https://">https://</Option>
            <Option value="http://">http://</Option>
          </Select>
        </FormControl>
        <FormControl sx={{ flex: 1 }}>
          <Input
            value={domain}
            onChange={(e) => onDomainChange(e.target.value)}
            placeholder={placeholder}
          />
        </FormControl>
      </Box>
    </Box>
  );
};
